import {
  FETCH_LOCATION_PRICES,
  FETCH_LOCATION_PRICES_SUCCESS,
  FETCH_LOCATION_PRICES_FAILED,
  EDIT_LOCATION_PRICE
} from "../store/types";

const INITIAL_STATE = {
  list: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const locationpricereducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_LOCATION_PRICES:
      return {
        ...state,
        loading: true
      };
    case FETCH_LOCATION_PRICES_SUCCESS:
      return {
        ...state,
        list: action.payload,
        loading: false
      };
    case FETCH_LOCATION_PRICES_FAILED:
      return {
        ...state,
        list: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case EDIT_LOCATION_PRICE:
      return state;
    default:
      return state;
  }
};